import React from 'react'
import { Grid } from '@material-ui/core';
import { ResponsiveContainer, BarChart, XAxis, YAxis, CartesianGrid, Tooltip, Bar, Cell } from 'recharts';
import LoadingContainer from '../../../../../../components_v1/Structure/Layouts/LoadingContainer'
import SimpleCard from '../../../../../../components_v1/Structure/Cards/SimpleCard';
import DisplayText from '../../../../../../components_v1/Texts/DisplayText';

const BChart = ({ data, title, loading, error, success, actions }) => {

    return (
        <LoadingContainer loading={loading} error={error} onCloseError={actions.onCloseError} success={success} onCloseSuccess={actions.onCloseSuccess}>
            <BarChartW title={title} {...data} />
        </LoadingContainer>
    )
}

const CustomTooltip = ({ payload, label, active }) => {

    if (active) {
        return (
            <div style={{ backgroundColor: 'black', padding: 10, height: 15, borderRadius: 10 }}>
                <p style={{ fontSize: 16, fontWeight: 500, color: 'white', margin: 0 }}>{payload[0].value}</p>
            </div>
        );
    }

    return null;
}

const BarChartW = ({ title, count, data }) => {
console.log(count)
    return (
        <SimpleCard>
            <Grid container justify='center' spacing={2}>
                <Grid item xs={12}>
                <DisplayText color='primary' style={{ fontSize: 20, fontWeight: 500 }} variant='body2'>{title} ({count})</DisplayText>
                </Grid>
                <Grid item xs={12}>
                    <ResponsiveContainer width="99%" height='100%' minHeight={400}>
                        <BarChart
                            data={data}
                            margin={{
                                top: 10,
                                right: 0,
                                left: 0,
                                bottom: 10,
                            }}
                        >
                            <XAxis
                                dataKey="name"
                                axisLine={false}
                                style={{ fontSize: 16, fontWeight: 500, color: '#455A64' }}
                                tick={{ fontFamily: 'Poppins' }}
                                tickLine={false}
                                tickMargin={20}
                            />
                            <YAxis
                                axisLine={false}
                                style={{ fontSize: 16, fontWeight: 600, color: '#455A64' }}
                                domain={[0, dataMax => dataMax > 0 ? Math.round(dataMax / 10) * 10 : 100]}
                                tick={{ fontFamily: 'Poppins' }}
                                tickLine={false}
                                tickMargin={20}
                            />
                            <Tooltip cursor={false} content={<CustomTooltip />} />
                            <CartesianGrid vertical={false} />
                            <Bar
                                type="monotone"
                                dataKey="score"
                                fill={data.color}
                                barSize={60}
                                radius={[10, 10, 0, 0]}
                            >
                                {data.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={`${entry.color}BF`} stroke={entry.color} />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </Grid>
            </Grid>
        </SimpleCard>
    )
}
export default BChart